import React, { useLayoutEffect, useRef } from 'react';
import { ICheckboxProps } from '../types';

const Checkbox = ({
  name,
  id,
  label,
  autoWidth,
  labelPosition = 'right',
  labelClassName = '',
  containerClassName = '',
  className = '',
  checked = '',
  isChecked = false,
  onCheck,
  item,
  onSelectItem,
  disabled = false,
  ...props
}: ICheckboxProps) => {
  const checkboxRef = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    if (checked === id || isChecked) {
      const checkbox = checkboxRef.current as HTMLInputElement;
      checkbox.checked = true;
      const customCheckbox = document.querySelector(`#custom-${id}`) as HTMLDivElement;
      customCheckbox.classList.add('checked');
    }
    if (!isChecked) {
      const checkbox = checkboxRef.current as HTMLInputElement;
      checkbox.checked = false;
      const customCheckbox = document.querySelector(`#custom-${id}`) as HTMLDivElement;
      if (customCheckbox) {
        customCheckbox.classList.remove('checked');
      }
    }
  }, [checked, id, isChecked, disabled]);

  const toggle = () => {
    if (disabled && !isChecked) {
      return;
    }
    const checkbox = document.querySelector(`#${id}`) as HTMLInputElement;
    const customCheckbox = checkbox.parentElement?.lastChild as HTMLDivElement;

    if (checkbox.checked) {
      customCheckbox.classList.add('checked');
    } else {
      customCheckbox.classList.remove('checked');
    }

    if (onSelectItem) {
      onSelectItem(item, checkbox.checked);
    }

    if (onCheck) {
      onCheck(id);
    }
  };

  const isDisabled = () => {
    if (disabled) {
      return 'disabled-box';
    }
    return '';
  };

  return (
    <label
      htmlFor={id}
      className={`smls-cross-sell-checkbox-container ${containerClassName} ${
        autoWidth ? 'stretch' : ''
      } ${isDisabled()}`.trim()}
      {...props}
    >
      <input hidden ref={checkboxRef} name={name} type="checkbox" id={id} onChange={toggle} />

      {label && (
        <span className={`checkbox-label-text ${labelPosition} ${labelClassName} ${isDisabled()}`.trim()}>{label}</span>
      )}

      <section
        id={`custom-${id}`}
        className={`checkbox-input custom ${className} ${isDisabled()}`.trim()}
        data-testid={id}
      >
        <i className="material-icons round">check</i>
      </section>
    </label>
  );
};

export default Checkbox;
